import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute, PrivateRouteAllStudies } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { StudiesList } from "./StudiesList";
import { PopulationGroupsList } from "../PopulationGroups/PopulationGroupsList";
import { CreatePopulationGroupScreen } from "../PopulationGroups/CreatePopulationGroupScreen";
import { CreateStudyScreen } from "./CreateStudyScreen";
import { EditStudyScreen } from "./EditStudyScreen";
import { CoughSettings } from "./Settings/CoughSettings";
import { EditPopulationGroupScreen } from "../PopulationGroups/EditPopulationGroupScreen";
import { StudyCustomisationScreen } from "./StudyCustomisationScreen";
import { SettingEditor } from "../../Settings/setting-editor-component";

export const StudiesScreen = () => {
    return (
        <Routes>
            <Route index element={
               <PrivateRouteAllStudies permissions={[PermissionEnum.ViewStudies, PermissionEnum.CreateStudy, PermissionEnum.EditStudy]}>
                <StudiesList />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="create" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.CreateStudy]}>
                <CreateStudyScreen />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="edit/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.EditStudy]}>
                <EditStudyScreen />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="populationgroups/create" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.CreatePopulationGroups]}>
                <CreatePopulationGroupScreen />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="populationgroups/edit/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.EditPopulationGroups]}>
                <EditPopulationGroupScreen />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="populationgroups/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.ViewPopulationGroups]}>
                <PopulationGroupsList />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="settings/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.EditStudy]}>
                <SettingEditor settingPath="" />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="CoughSettings/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.EditStudy]}>
                <CoughSettings />
                </PrivateRouteAllStudies>
            }
            />
            <Route path="customisation/:id" element={
                <PrivateRouteAllStudies permissions={[PermissionEnum.CustomiseStudy]}>
                <StudyCustomisationScreen />
                </PrivateRouteAllStudies>
            }
            />
        </Routes>
    );
}
